import axios from "axios";
import queryString from "query-string";
import StorageHelper from "../utilities/StorageHelper";
import AppConfig, {
  AUTH_STATUS_ERROR_CODE,
  SYSTEM_ROLE,
} from "../config/AppConfig";
import history from "../router/history";
const { STORAGE_KEYS } = AppConfig;

const getAuthInfo = async () => {
  // Call API get token
  return StorageHelper.getCookie(STORAGE_KEYS.token) || "";
};
const handleUnauthorized = async (status) => {
  if (AUTH_STATUS_ERROR_CODE.includes(status)) {
    const user = StorageHelper.getLocalObject(STORAGE_KEYS.user);
    let url = "/auth/worker/login";
    if (user && user.role) {
      switch (user.role) {
        case SYSTEM_ROLE.SUPER_ADMIN:
        case SYSTEM_ROLE.MANAGER:
          url = "/auth/login";
          break;
        case SYSTEM_ROLE.HOSPITAL_ADMIN:
        case SYSTEM_ROLE.HOSPITAL_OTHER:
        case SYSTEM_ROLE.COORDINATOR_ADMIN:
        case SYSTEM_ROLE.COORDINATOR_OTHER:
        case SYSTEM_ROLE.PARTICIPANT:
          url = "/auth/client/login";
          break;
        case SYSTEM_ROLE.NURSE:
        case SYSTEM_ROLE.SUPPORT_WORKER:
          url = "/auth/worker/login";
          break;
        case SYSTEM_ROLE.COMPANY:
          url = "/auth/company/login";
          break;
        default:
          break;
      }
      await StorageHelper.removeCookie(STORAGE_KEYS.token);
      await StorageHelper.removeLocalItem(STORAGE_KEYS.user);
      history.push(url);
    }
  }
};
// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  const token = await getAuthInfo();
  if (token) {
    config.headers["X-Auth-Token"] = `${token}`;
  }

  return config;
});

axiosClient.interceptors.response.use(
  async (response) => {
    await handleUnauthorized(response.data.status);
    return response;
  },
  async (error) => {
    // Handle errors
    const status = error.status || error.response.data.status;
    await handleUnauthorized(status);
    throw error.response.data;
  }
);

export default axiosClient;
